import Vue from 'vue'
import VueI18n from 'vue-i18n'

import enLocale from 'element-ui/lib/locale/lang/en'; // 英文语言包
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'; // 中文语言包

Vue.use(VueI18n)
// 以下为语言包单独设置的场景，单独设置时语言包需单独引入
const messages = {
  'en': { ...require('./i18n/en.json'), ...enLocale }, // 英文语言包
  'zh': { ...require('./i18n/zh.json'), ...zhLocale } // 中文语言包
  // 'zh_Hant': require('./i18n/zh_Hant.json'), // 繁体中文语言包
  // 'he': require('./i18n/he.json'), // 希伯来语言包
  // 'fr': require('./i18n/fr.json'), // 法语语言包
  // 'es': require('./i18n/es.json'), // 西班牙语言包
  // 'vi': require('./i18n/vi.json') // 
  // 'ar': require('./i18n/ar.json'),   // 阿拉伯语语言包
}

// 最后 export default，这一步肯定要写的。
export default new VueI18n({
  locale: 'zh', // set locale 默认显示中文
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true
});



// WEBPACK FOOTER //
// ./src/utils/i18n.js